<template>
    <v-dialog v-model="showSavedCardLabelForm" width="500">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    <div
                        class="d-flex justify-space-between align-center"
                        style="width: -webkit-fill-available"
                    >
                        <div><TranslatableStringComponent :tstring="{string: 'labelSavedCart'}" /></div>
                        <v-btn icon @click="$emit('closeDialog')">
                            <fa :icon="['fal', 'times']" class="fa-lg" />
                        </v-btn>
                    </div>
                </v-card-title>
                <v-card-text class="pt-4">
                    <p><TranslatableStringComponent :tstring="{string: 'wouldYouLikeToLabelYourSavedCart'}" /></p>
                    <v-text-field
                        v-model.number="localLabel"
                        label="Saved Cart Label (optional)"
                        outlined
                        dense
                        :hide-details="true"
                    ></v-text-field>
                </v-card-text>
                <v-card-actions class="pr-4 justify-end">
                    <v-btn color="primary" @click="$emit('saveLabel',localLabel)"><TranslatableStringComponent :tstring="{string: 'save'}" /></v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
</template>
<script>
import TranslatableStringComponent from '~/components/TranslatableStringComponent.vue' 
export default {
    name: 'LabelSavedCartDialog',
    components: {
        TranslatableStringComponent,
    },
    props: {
        showSavedCardLabelForm: {
            type: Boolean,
            default: false
        },
        label: {
            type: String,
            default: '',
        }
    },
    data() {
        return {
            localLabel: '',
        }
    },
    watch: {
        showSavedCardLabelForm(newVal){
            if(newVal)
                this.localLabel = this.label
        }
    }
    
}
</script>
